<template>
  <div class="zbhxr" v-if="kbxmlc">
    <div :class="['box', kbxmlc.zt == '2' || role != 'Z' ? 'noBtn' : '']">
      <div class="clear">
        <p class="cont-title lf">推荐中标候选人</p>
        <div class="rt">
          <template v-if="role == 'Z' && newOrOld == '0'">
            <el-button
              type="primary"
              @click="draw"
              :disabled="codeBtnDisabel(tableData) || waitLoading"
              >抽取编号</el-button
            >
          </template>
        </div>
      </div>
      <p class="tip">推荐中标候选人个数: {{ zbhxrgsNum }}</p>
      <el-table ref="table" border :data="tableData" style="width: 100%">
        <el-table-column type="index" label="编号" width="60"></el-table-column>
        <el-table-column
          prop="companyName"
          label="投标单位名称"
          show-overflow-tooltip
          min-width="200"
          ><template slot-scope="scope">
            <div style="display: flex; align-items: center">
              <p>{{ scope.row.companyName }}</p>
              <div
                v-if="scope.row.lhtShowOrNo == 1"
                style="margin-left: 20px"
                class="btn-lht"
                @click="openLht(scope.row.lhtId)"
              >
                联合体
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in extraHead"
          :key="item.prop"
          :label="item.label"
          :prop="item.prop"
        ></el-table-column>

        <el-table-column
          v-for="item in exhibitionList"
          :key="item.prop"
          :label="item.mc"
          :prop="item.prop"
        ></el-table-column>

        <el-table-column
          prop="winningCandidate"
          label="推荐中标候选人"
          width="200"
        >
          <template slot-scope="scope">
            <template v-if="newOrOld == '0'">
              <el-radio
                v-if="kbxmlc.zt != '2' && role == 'Z'"
                v-model="zbhxr"
                :label="scope.row.companyCode"
                @change="saveWinningCandidate(scope.row)"
                >第一中标候选人</el-radio
              >
              <template v-else>
                {{ scope.row.winningCandidate == 1 ? "第一中标候选人" : "" }}
              </template>
            </template>
            <template v-else>
              <el-select
                v-model="scope.row.winningCandidate"
                placeholder="请选择"
                value-key="value"
                :disabled="!isSelectDisabeled"
                @change="saveWinningCandidate(scope.row)"
              >
                <el-option
                  v-for="item in newOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-button
      type="primary lcNext"
      @click="nextBtn"
      v-if="kbxmlc.zt != '2' && role == 'Z'"
      >下一步</el-button
    >
    <lht-mark
      v-if="lhtVisible"
      :visible.sync="lhtVisible"
      :lhtId="lhtId"
    ></lht-mark>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
  <script>
import lhtMark from "@/components/lhtMark/index.vue";
import { numberToChinese } from "@/utils";
export default {
  name: "tjzbhxr", //开评一体 推荐中标候选人
  components: { lhtMark },
  data() {
    return {
      waitLoading: false,
      kbxmlc: "",
      djlcId: "", //当前节点状态
      tableData: [],
      zbhxr: null,
      currentPage: 1,
      pageSize: 10,
      isOk: false, //是否提交保存过中标候选人
      options: [
        { label: "请选择", id: 0 },
        { label: "第一中标候选人", id: 1 },
      ],
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      unit: "",
      newOrOld: "0",
      exhibitionList: [],
      extraHead: [],
      zbhxrgsNum: 0,
      newOptions: [],
      lhtVisible: false,
      lhtId: "",
    };
  },
  computed: {
    // select能否可选
    isSelectDisabeled() {
      return (
        this.kbxmlc.zt == "1" &&
        ["T", "A", "Z"].includes(this.role) &&
        this.newOrOld === "1"
      );
    },
    codeBtnDisabel() {
      return (res) => {
        if (res.length > 1) {
          let arr = res.map((el) => {
            return el.rank == "1";
          });
          if (arr.length > 1) {
            return false && kbxmlc.zt == "2";
          }
        } else {
          return true;
        }
      };
    },
  },
  beforeDestroy() {
    window.removeEventListener("storage");
  },
  methods: {
    openLht(id) {
      this.lhtVisible = true;
      this.lhtId = id;
    },
    getNewOptions(data) {
      let arr = [{ label: "请选择", value: 0 }];
      for (let i = 0; i < data; i++) {
        let obj = {
          label: `第${numberToChinese(i + 1)}中标候选人`,
          value: i + 1,
        };
        arr.push(obj);
      }
      return arr;
    },
    getData() {
      let para = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        tbdwmc: this.tbdwmc,
        djlcId: this.djlcId,
      };
      this.waitLoading = true;
      this.$api
        .getWinningCandidateList(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.waitLoading = false;
            this.kbxmlc = res.data.data.kbxmlc;
            this.newOrOld = res.data.data.newOrOld;
            // 新逻辑
            if (res.data.data.newOrOld === "1") {
              this.unit = res.data.data.unit;
              this.zbhxrgsNum = res.data.data.zbhxrgsNum;
              this.newOptions = this.getNewOptions(this.zbhxrgsNum);
              this.tableData = res.data.data.newPageInfo.list || [];
              this.tableData.forEach((el) => {
                if (
                  el.attributeMap &&
                  JSON.stringify(el.attributeMap) !== "{}"
                ) {
                  for (let key in el.attributeMap) {
                    el[key] = el.attributeMap[key];
                  }
                }
              });
              // 对中间值进行排序 并预设中间值的取值键名
              this.exhibitionList = (res.data.data.exhibition || [])
                .sort((a, b) => a.pxh - b.pxh)
                .map((item, index) => {
                  return {
                    ...item,
                    prop: `exhibition${index}`,
                  };
                });
              this.extraHead = res.data.data.head.map((el) => {
                return {
                  label: el.name,
                  prop: el.code,
                };
              });
              this.tableData.forEach((el) => {
                if (el.complianceReview === "0") {
                  el.complianceReview = "";
                  // 如果数据列表中 exhibition字段存在且不为空 则按照预设键名新增键并赋值
                }
                if (el?.exhibition) {
                  el.exhibition.split(",").forEach((item, index) => {
                    el[`exhibition${index}`] = item;
                  });
                } else {
                  // 如果无值 则预设键名 并赋值为空
                  this.exhibitionList.forEach((item) => {
                    el[item.prop] = "";
                  });
                }
              });
            } else {
              this.tableData = res.data.data.page.list;
              let a =
                this.tableData.find((a) => a.winningCandidate == "1") || {};
              console.log(a);
              this.zbhxr = a ? a.companyCode : null;
            }
            this.getWinningCandidateFlag();
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.mesage,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    async saveWinningCandidate(row) {
      try {
        let para = [];
        let obj = { ...row };
        if (this.newOrOld == "0") {
          obj.winningCandidate = "1";
        }
        para.push(obj);
        this.waitLoading = true;
        let res = await this.$api.saveWinningCandidate({
          projectResultInfo: para,
        });
        if (res.status == 200) {
          this.getWinningCandidateFlag();
          this.getData();
        } else {
          this.$message({ type: "error", message: res.message });
        }
        this.waitLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async getWinningCandidateFlag() {
      try {
        this.waitLoading = true;
        let res = await this.$api.getWinningCandidateFlag({
          djlcId: this.djlcId,
        });
        if (res.status == 200) {
          this.isOk = res.data.data;
        } else {
          this.$message({ type: "error", message: res.message });
        }
        this.waitLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    handleNext(arr) {
      const candidates = new Set();
      for (let i = 0; i < arr.length; i++) {
        const candidate = arr[i].winningCandidate;
        if (candidates.has(candidate) && candidate !== 0) {
          return false;
        }
        candidates.add(candidate);
      }
      return true;
    },
    nextBtn() {
      if (this.handleNext(this.tableData)) {
        let para = {
          flag: this.kbxmlc.ycdz,
        };
        this.waitLoading = true;
        this.$emit("nextBtn", para);
      } else {
        this.$message({
          type: "warning",
          message: "推荐中标候选人不能重复",
        });
      }
    },
    draw() {
      // 打开新标签 并且监听新标签抽中的参数
      let _this = this;
      let arr = _this.tableData.map((el, index) => {
        if (el.rank == "1") {
          return index + 1;
        }
      });
      let url = `/draw?userData=${encodeURIComponent(JSON.stringify(arr))}`;
      window.open(url, "_blank");
      window.addEventListener("storage", function (event) {
        if (event.key === "myParam" && event.newValue !== null) {
          // 从新标签页传递回来的参数
          const param = JSON.parse(event.newValue);
          if (param.result.length > 0) {
            _this.saveWinningCandidate(_this.tableData[param.result[0].jg - 1]);
            _this.zbhxr = _this.tableData[param.result[0].jg - 1].companyCode;
          }
        }
      });
    },
  },
  mounted() {
    this.djlcId = this.$route.query.djlcId;
    this.getData();
  },
};
</script>
  <style lang="less">
.zbhxr {
  td {
    .el-input__inner,
    .el-input__icon {
      height: 29px;
      line-height: 29px;
    }
  }
}
.tip {
  color: #d70a30;
}
</style>